export const convertDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const convertDateToIndianFormat = (dateString) => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
};
// utils/dateUtils.js

export const isTimeUp = (targetDateString) => {
  // Parse the target date string (e.g., "2025-08-10T18:00:00")
  const targetDate = new Date(targetDateString);

  // Get the current date and time in the 'Asia/Kolkata' timezone
  const currentDate = new Date();

  // Offset the current date to IST (UTC +5:30)
  const currentOffsetInMs = currentDate.getTimezoneOffset() * 60 * 1000;
  const indiaOffsetInMs = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30

  // Calculate the current time in IST
  const currentISTDate = new Date(
    currentDate.getTime() + currentOffsetInMs + indiaOffsetInMs
  );

  // Compare the current time in IST with the target date
  return currentISTDate > targetDate;
};

export const validateEmail = (email) => {
  const emailProducerRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (emailProducerRegex.test(email)) return true;
  return false;
};
export const handleKeyDown = (event) => {
  // Prevent the letter 'e', '+', '-', '.' and other non-numeric characters
  if (["e", "E", "+", "-", "."].includes(event.key)) {
    event.preventDefault();
  }
};

export const calculateAge = (birthDateString) => {
  const birthDate = new Date(birthDateString);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  // Adjust age if the current date is before the birth date
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const validatePdf = (selectedFile) => {
  let returnData = {
    status: true,
  };
  if (selectedFile) {
    if (selectedFile.type !== "application/pdf") {
      // setError('Please select a PDF file');
      returnData.status = false;
      returnData.message = "Please select a PDF file";
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      returnData.status = false;
      returnData.message = "File size should be less than 5 MB";
    }
  }
  return returnData;
};

export const validateFile = (selectedFile) => {
  let returnData = {
    status: true,
  };
  if (selectedFile) {
    const allowedTypes = ["application/pdf", "image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(selectedFile.type)) {
      returnData.status = false;
      returnData.message = "Please select a PDF, JPEG, or JPG file";
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      returnData.status = false;
      returnData.message = "File size should be less than 5 MB";
    }
  }
  return returnData;
};

export const validateFileall = (selectedFile) => {
  let returnData = {
    status: true,
  };
  if (selectedFile) {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/msword",
    ];
    if (!allowedTypes.includes(selectedFile.type)) {
      returnData.status = false;
      returnData.message = "Please select a PDF, PNG, JPEG, or JPG file";
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      returnData.status = false;
      returnData.message = "File size should be less than 5 MB";
    }
  }
  return returnData;
};

export const validateDoc = (selectedFile) => {
  let returnData = {
    status: true,
  };

  if (selectedFile) {
    const validTypes = [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!validTypes.includes(selectedFile.type)) {
      returnData.status = false;
      returnData.message = "Please select a DOC or DOCX file";
      return returnData; // Early return if file type is not valid
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      returnData.status = false;
      returnData.message = "File size should be less than 5 MB";
    }
  }

  return returnData; // Ensure returnData is returned
};

export const validateImage = (selectedFile) => {
  let returnData = {
    status: true,
  };

  if (selectedFile) {
    const validTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!validTypes.includes(selectedFile.type)) {
      returnData.status = false;
      returnData.message = "Please select a JPG or JPEG or PNG file";
      return returnData; // Early return if file type is not valid
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      returnData.status = false;
      returnData.message = "File size should be less than 5 MB";
    }
  }

  return returnData; // Ensure returnData is returned
};
